import React from "react";
import GeoFlag from "./GeoFlag";
import { geoShort } from "../../constants";

function shortName(geoItem) {
  return geoShort[geoItem.id] || "?";
}

const GeoView = ({ geo = [], isExclude }) => {
  let geoList;
  let after = "";

  if (geo.length > 2) {
    geoList = geo.slice(0, 2);
    after = "+";
  } else {
    geoList = geo;
  }

  if (geo.length == []) {
    return <div className="geo-view">Все страны</div>;
  }

  return (
    <div className="geo-view">
      {geoList.map(geoItem => {
        if (!geoItem.code || (geoItem.code || "").match(/\d+/)) {
          return <span>{shortName(geoItem)}</span>;
        }
        return (
          <GeoFlag
            key={geoItem.id}
            code={geoItem.code}
            name={geoItem.name}
            isExclude={isExclude}
          />
        );
      })}{" "}
      {after}
    </div>
  );
};

export default GeoView;
